import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n  height: ", "em;\n  justify-content: center;\n  width: ", "em;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " ", "s infinite linear;\n  border: ", "em solid ", ";\n  border-left: ", "em solid ", ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: inline-block;\n  height: calc(100% - ", "em);\n  transform: translateZ(0);\n  width: calc(100% - ", "em);\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: ", ";\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: auto;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n  margin-right: ", "px;\n  opacity: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      border-style: solid;\n      border-width: 1px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: inline-flex;\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", "px;\n  justify-content: center;\n  margin: 0;\n  opacity: ", ";\n  padding: ", ";\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: background-color ", ", color ", ";\n  width: ", ";\n\n  ", "\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &[disabled] {\n    cursor: not-allowed;\n\n    /* hide styles added by withRippleEffect() */\n    &::before {\n      display: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { position } from 'polished';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color, property, typography } from '@scp/ui-shared/theme/variables';
import { DURATION, spinAnimation } from '@scp/ui-shared/components/Loader';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { LinkOrButton } from './LinkOrButton';
export var BUTTON_SIZE = {
  fontSize: typography.defaultFontSize,
  iconEm: 1.5714,
  padding: 16,
  iconPadding: 8,
  height: 30,
  largeHeight: 50
};
var LOADER_SIZE = {
  loaderWrapperEm: BUTTON_SIZE.iconEm,
  loaderWrapperPaddingEm: 0.1428,
  borderEm: 0.1746
};
var PROPS_TO_OMIT = ['buttonAppearance', 'buttonColor', 'reversed', 'hasIcon', 'navigatingByKeyboard'];

var getButtonStyleProps = function getButtonStyleProps(_ref) {
  var secondary = _ref.secondary,
      outline = _ref.outline,
      danger = _ref.danger,
      appearance = _ref.appearance,
      color = _ref.color;
  var styleProps = {
    buttonAppearance: appearance,
    buttonColor: color
  };
  if (secondary) styleProps.buttonAppearance = 'secondary';
  if (outline) styleProps.buttonAppearance = 'outline';
  if (danger) styleProps.buttonColor = 'danger';
  return styleProps;
};

var getButtonBackgroundColor = function getButtonBackgroundColor(_ref2) {
  var buttonAppearance = _ref2.buttonAppearance,
      buttonColor = _ref2.buttonColor;

  switch (buttonAppearance) {
    case 'secondary':
    case 'outline':
      return 'transparent';

    default:
      return buttonColor === 'danger' ? color.alert : color.action;
  }
};

var getTextColor = function getTextColor(_ref3) {
  var transparent = _ref3.transparent,
      buttonAppearance = _ref3.buttonAppearance,
      buttonColor = _ref3.buttonColor;
  if (transparent) return 'transparent';

  switch (buttonAppearance) {
    case 'secondary':
    case 'outline':
      return buttonColor === 'danger' ? color.alert : color.action;

    default:
      return color.palette.white;
  }
};

var getBackgroundHoverColor = function getBackgroundHoverColor(props) {
  if (props.disabled) return getButtonBackgroundColor(props); // don't change on hover

  switch (props.buttonAppearance) {
    case 'secondary':
    case 'outline':
      return getButtonBackgroundColor(props);
    // don't change on hover

    default:
      return props.buttonColor === 'danger' ? color.alertHover : color.actionHover;
  }
};

var getTextHoverColor = function getTextHoverColor(props) {
  if (props.transparent) return 'transparent';
  if (props.disabled) return getTextColor(props);

  switch (props.buttonAppearance) {
    case 'secondary':
    case 'outline':
      return props.buttonColor === 'danger' ? color.alertHover : color.actionHover;

    default:
      return getTextColor(props);
  }
};

var getPadding = function getPadding(_ref4) {
  var hasIcon = _ref4.hasIcon,
      reversed = _ref4.reversed;

  if (hasIcon) {
    return reversed ? "0 ".concat(BUTTON_SIZE.iconPadding, "px 0 ").concat(BUTTON_SIZE.padding, "px") : "0 ".concat(BUTTON_SIZE.padding, "px 0 ").concat(BUTTON_SIZE.iconPadding, "px");
  }

  return "0 ".concat(BUTTON_SIZE.padding, "px");
};

var getLoaderPosition = function getLoaderPosition(_ref5) {
  var $centered = _ref5.$centered,
      $reversed = _ref5.$reversed;
  if ($centered) return position('absolute', null);
  if ($reversed) return position('absolute', null, 0, null, null);
  return position('absolute', null, null, null, 0);
};

var StyledButton = styled(LinkOrButton).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject(), getButtonBackgroundColor, property.borderRadius, getTextColor, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, BUTTON_SIZE.fontSize, typography.fontWeightBold, function (props) {
  return props.large ? BUTTON_SIZE.largeHeight : BUTTON_SIZE.height;
}, function (props) {
  return props.disabled ? 0.5 : 1;
}, getPadding, property.transition, property.transition, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (_a) {
  var transparent = _a.transparent,
      buttonAppearance = _a.buttonAppearance,
      rest = __rest(_a, ["transparent", "buttonAppearance"]);

  return buttonAppearance === 'outline' && css(_templateObject2(), getTextColor(Object.assign({
    buttonAppearance: buttonAppearance
  }, rest)));
}, getBackgroundHoverColor, getTextHoverColor);
var ButtonWithRipple = withRippleEffect(StyledButton, undefined, false);
var ButtonIcon = styled(Icon).attrs({
  color: 'currentColor'
})(_templateObject3(), function (props) {
  return props.$reversed ? BUTTON_SIZE.iconPadding : 0;
}, function (props) {
  return !props.$reversed ? BUTTON_SIZE.iconPadding : 0;
}, function (props) {
  return props.$hidden ? 0 : 1;
});
var ButtonContent = styled.span(_templateObject4(), function (props) {
  return props.reversed ? 'row-reverse' : 'row';
});
var Loader = styled.span(_templateObject5(), spinAnimation, DURATION, LOADER_SIZE.borderEm, color.palette.grey800, LOADER_SIZE.borderEm, color.palette.grey200, LOADER_SIZE.loaderWrapperPaddingEm, LOADER_SIZE.loaderWrapperPaddingEm);
var LoaderWrapper = styled.span(_templateObject6(), BUTTON_SIZE.iconEm, BUTTON_SIZE.iconEm, getLoaderPosition);
/**
 * A generic button component.
 *
 * Extends `LinkOrButton`, so it can be a link,
 * span or button that always looks like a button.
 *
 * @example ./__docs__/Button.md
 */

export var Button = function Button(props) {
  var secondary = props.secondary,
      children = props.children,
      iconName = props.iconName,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      reversed = props.reversed,
      outline = props.outline,
      danger = props.danger,
      dataE2e = props.dataE2e,
      isLoading = props.isLoading,
      disabled = props.disabled,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      otherProps = __rest(props, ["secondary", "children", "iconName", "type", "reversed", "outline", "danger", "dataE2e", "isLoading", "disabled", "appearance", "color"]);

  var _getButtonStyleProps = getButtonStyleProps({
    secondary: secondary,
    outline: outline,
    danger: danger,
    appearance: appearance,
    color: color
  }),
      buttonAppearance = _getButtonStyleProps.buttonAppearance,
      buttonColor = _getButtonStyleProps.buttonColor;

  var dataE2ELabel = getE2eLabel(children, '', dataE2e);
  var isDisabled = disabled || isLoading;
  var hideText = isLoading && !iconName;
  return React.createElement(ButtonWithRipple, Object.assign({
    hasIcon: !!iconName,
    reversed: reversed,
    type: type,
    dataE2e: dataE2ELabel,
    disabled: isDisabled,
    transparent: hideText,
    buttonAppearance: buttonAppearance,
    buttonColor: buttonColor
  }, otherProps), React.createElement(ButtonContent, {
    reversed: reversed
  }, isLoading && React.createElement(LoaderWrapper, {
    "$centered": hideText,
    "$reversed": reversed
  }, React.createElement(Loader, {
    role: "progressbar"
  })), !!iconName && React.createElement(ButtonIcon, {
    "$hidden": isLoading,
    "$reversed": reversed,
    name: iconName,
    size: "".concat(BUTTON_SIZE.iconEm, "em")
  }), children));
};